<template>
  <div class="ask-show-answer">
    <van-nav-bar
    v-if="source==1&&pageLength>1"
    :title="info.question"
    left-arrow
    :fixed="true"
    @click-left="onClickLeft"
    />
    <van-nav-bar
    v-if="source==1&&pageLength==1"
    :title="info.question"
    :fixed="true"
    @click-left="onClickLeft">
    <template #left>
      <van-icon name="wap-home-o" size="18" />
    </template>
  </van-nav-bar>
    <div class="q-show" :style="{'margin-top':source==1?'50px':'0'}" v-if="info">
      <h1 v-if="info.question">
        <img class="quespic" :src="img.question" />
        {{ info.question }}
      </h1>
      <p>{{ info.content }}</p>
      <img class="img" v-for="(img, index) in info.image" :key="'img_' + index" v-lazy="img" />
      <div class="other" v-if="info.answer_num">
        <router-link class="f-12 c-blue" :to="{name: 'AskShow', params: {id: info.id}}">查看其它{{ info.answer_num }}个回答&gt;</router-link>
      </div>
      <div class="tag">
        <van-row type="flex" justify="space-between">
          <van-col span="18">
            <van-tag plain v-for="t in info.labels" :key="'label_' + t.id + '_id_' + info.id">{{ t.name }}</van-tag>
          </van-col>
          <van-col span="6" class="tip">
            <router-link class="c-blue" to="">我要回答</router-link>
          </van-col>
        </van-row>
      </div>
    </div>
    <div class="a-show" v-if="info && info.answer">
      <van-row type="flex" justify="space-between" v-if="info.answer.user">
        <van-col span="4">
          <img class="listhand" :src="info.answer.user.headimg_url ? info.answer.user.headimg_url : img.avatar">
        </van-col>
        <van-col span="20">
          <div class="membername">
            {{info.answer.user.user_name}}
          </div>
          <div class="sourtime">
            {{info.answer.answer_time}}
          </div>
        </van-col>
      </van-row>
      <div class="f-14">
        <img class="quespic" :src="img.answer">
        <span v-for="(item, index) in info.answer.content" :key="'a_c_' + index">
          {{ item.text }}
          <img v-if="item.img" v-lazy="item.img" class="img" />
        </span>
      </div>

      <div class="parise">
        <router-link to="" @click.native="setAdopt">
          <img :src="info.answer.is_adopt ? img.parise_have : img.show_parise" />
          采纳答案
        </router-link><router-link to="" @click.native="setNoPraise">
          <img :src="info.answer.is_praiseno ? img.no_parise_have : img.show_no_parise" />
          没帮助
        </router-link><router-link to="">
          <img :src="img.answer_black" />
          追加问题
        </router-link>
      </div>
      <van-row type="flex" justify="space-between">
        <van-col span="14">
          <span class="sourtime" v-if="info.read_num">阅读量{{ info.read_num }}</span>
        </van-col>
        <van-col class="bintright" span="10">
          <span class="sourtime" @click="toTip">举报</span>
        </van-col>
      </van-row>
    </div>
    <!-- 评论 -->
    <div class="comments">
      <h2>全部评论</h2>
      <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
      >
      <div slot="loading" class="list-loading">
        <img :src="this.img.loading" />
        <span>正在刷新</span>
      </div>
      <div class="comment">
        <van-row gutter="15" v-for="(comment, index) in comments" :key="'commment_' + comment.id">
          <van-col span="3">
            <img class="avatar" :src="comment.user && comment.user.headimg_url ? comment.user.headimg_url : img.avatar" />
          </van-col>
          <van-col span="21">
            <h3>
              {{ comment.user.user_name }}
              <span class="binbox">
                <img class="binpic" @click="setCommentPraise(index)" :src="comment.is_praise ? img.parise_have : img.parise">
                <span class="sourtime">{{ comment.praise_num }}</span>
              </span>
            </h3>
            <p v-if="comment.content">{{ comment.content }}</p>
            <van-row class="ct">
              <van-col span="14">
                <span class="f-12 c-gray">{{ comment.create_time }}
                  <span class="c-black" @click="replys(comment.id)"> · 回复
                    <span v-if="comment.replys">({{ comment.reply_num }})</span>
                  </span>
                </span>
              </van-col>
              <van-col span="10" class="text-r">
                <span v-if="comment.user.id==params.user_id" class="f-12" @click="delComment(comment.id,index)">删除</span>
                <span v-else class="f-12" @click="toTip">举报</span>
              </van-col>
            </van-row>
            <div class="replys" v-if="comment.reply_num>0">
              <p v-for="reply in comment.replys" :key="'replys_' + reply.id">
                <span class="c-blue" v-if="reply.user">{{ reply.user.user_name }}</span>
                <span v-if="reply.reuser">回复<span class="c-blue">{{ '@' + reply.reuser.user_name }}</span></span>
                {{ reply.content }}
              </p>
              <div class="other">
                <router-link class="f-12 c-blue" :to="{name: 'AskShowComment', params: {id: comment.id,answerid:answer_id}}">共{{ comment.reply_num }}条回复&gt;</router-link>
              </div>
            </div>
          </van-col>
        </van-row>
      </div>
    </van-list>
  </div>
  <div @touchstart="touchstart()" class="postoverlay" v-show="overlay"></div>
  <div class="postbottom" id="inputid" v-if="nobrowser">
    <van-row>
      <van-col :span="inputnum">
        <van-field v-model="value" @click="inputFocus()" :focus="inputfocus" placeholder="发表评论..." ref="inputTag" />
      </van-col>
      <van-col  v-if="inputshow" class="botright" span="10">
        <van-row>
          <van-col span="8"> 
            <span class="binbox">
              <img class="binpic" :src="img.comment">
              <span class="num" v-if="info.answer.reply_num>0">{{info.answer.reply_num}}</span>
            </span>
          </van-col>
          <van-col span="10">
            <span class="binbox" @click="Collect(info.answer.is_collect)">
              <img class="binpic" :src="info.answer.is_collect==1?img.collect_have:img.collect">
              <span class="num" v-if="info.collect_num>0">{{info.collect_num}}</span>
            </span>
          </van-col>
          <van-col span="6">
            <span class="binbox" @click="outrelay(info.question,info.content,'/ask/'+info.answer.id+'/answer',info.image[0])">
              <img class="binpic" :src="img.outrelay">
            </span>
          </van-col>
        </van-row>
      </van-col>
      <van-col v-else span="5">
        <van-button color="#F6AB00" size="small" @click="post()">发表</van-button>
      </van-col>
    </van-row>
  </div>
  <van-action-sheet v-model="shareshow" :round="false" cancel-text="取消" @cancel="onCancel">
    <van-divider class="divider">分享</van-divider>
    <van-grid :border='false' :column-num="2">
      <van-grid-item :icon="img.friends" @click="toShare(2)" />
      <van-grid-item :icon="img.wechat" @click="toShare(1)" />
    </van-grid>
  </van-action-sheet>
</div>
</template>

<script>
  import ask from '../../../api/ask';
  import { mapState } from 'vuex';
  import {Row, Col, Tag,NavBar,Grid, GridItem,List,Field,Button,Overlay,ActionSheet,Divider,Icon } from "vant";
  export default {
    data () {
      return {
        params: {
          page: 1,
          size: 4,
          order: 1,
          user_id: 0
        },
        answer_id: 0,
        loading: false,
        finished: false,
        info: null,
        comments: [],
        value:'',
        inputshow:true,
        overlay:false,
        inputfocus:false,
        inputnum:14,
        rid:'',
        shareshow:false,
        nobrowser:false,
        pageLength:1,
        img: {
          avatar: require('../../../assets/img/default.jpg'),
          parise: require('../../../assets/img/parise.png'),
          parise_have: require('../../../assets/img/parise_have.png'),
          no_parise: require('../../../assets/img/no_parise.png'),
          show_parise: require('../../../assets/img/show_parise.png'),
          show_no_parise: require('../../../assets/img/show_no_parise.png'),
          no_parise_have: require('../../../assets/img/no_parise_have.png'),
          loading: require('../../../assets/img/loading.gif'),
          question: require('../../../assets/img/question.png'),
          answer: require('../../../assets/img/answers.png'),
          answer_black: require('../../../assets/img/answer-button-black.png'),
          collect: require('../../../assets/img/collect.png'),
          collect_have: require('../../../assets/img/collect_have.png'),
          comment: require('../../../assets/img/lexus/comment.png'),
          outrelay: require('../../../assets/img/lexus/outrelay.png'),
          friends: require('../../../assets/img/friend.png'),
          wechat: require('../../../assets/img/wecheck.png'),
        }
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    watch: {
      '$route'() {
        if(this.$route.params.id != this.answer_id) {
          this.answer_id = this.$route.params.id
          this.getInfo()
        }
      }
    },
    created () {
      this.pageLength=window.history.length
      this.weburl=process.env.VUE_APP_URL
      if(this.source == 3||this.source == 7) {
        this.$appService.isShowReturn({state: true})
      }

      this.$store.commit('param/show', false)
      let id = this.$route.params.id
      if(this.$util.isEmpty(id)) {
        this.$toast('答案不存在')
        return false
      }
      if(localStorage.getItem('browser')){
        this.nobrowser=false
      }else{
        this.nobrowser=true
      }
      this.answer_id = id

      this.getInfo()
    },
    methods: {
      setAdopt () {
        if(this.source == 3||this.source == 7) {
          this.$appService.getToken(v => {
            if(v.token) {
              this.$store.dispatch('param/setToken', v.token)
            } else {
             var params={
              url:'',
              pagetype:0
            }
            this.$appService.needLogin(params)
          }
        })
        }else if(this.source == 1){
          if(localStorage.getItem('token')){
            this.token=true
          }else{
            this.getAuthorization.getAuthorization();
          }
        }

        if(this.user) {
          let type = this.info.answer.is_adopt ? 2 : 1;
          ask.setAdopt({id: this.info.answer.id, type: type}).then(res => {
            if(res.data.state == 1) {
              if(type == 1) {
                this.info.answer.is_adopt = 1
                this.$toast.success('采纳成功')

              //取消一般般
              if(this.info.answer.is_praiseno) {
                ask.setNoPraise({id: this.info.answer.id, type: 2}).then(res => {
                  this.info.answer.is_praiseno = 0
                })
              }
            } else {
              this.info.answer.is_adopt = 0
              this.$toast.success('取消成功')
            }
          }
        })
        } else {
          this.$toast('请先登录')
          return false
        }
      },
      setNoPraise () {
        if(this.source == 3||this.source == 7) {
          this.$appService.getToken(v => {
            if(v.token) {
              this.$store.dispatch('param/setToken', v.token)
            } else {
             var params={
              url:'',
              pagetype:0
            }
            this.$appService.needLogin(params)
          }
        })
        }else if(this.source == 1){
          if(localStorage.getItem('token')){
            this.token=true
          }else{
            this.getAuthorization.getAuthorization();
          }
        }

        if(this.user) {
          let type = this.info.answer.is_praiseno ? 2 : 1;
          ask.setNoPraise({id: this.info.answer.id, type: type}).then(res => {
            if(res.data.state == 1) {
              if(type == 1) {
                this.info.answer.is_praiseno = 1
                this.$toast.success('成功')

              //取消采纳
              if(this.info.answer.is_adopt) {
                ask.setAdopt({id: this.info.answer.id, type: 2}).then(res => {
                  this.info.answer.is_adopt = 0
                })
              }
            } else {
              this.info.answer.is_praiseno = 0
              this.$toast.success('取消成功')
            }
          }
        })
        } else {
          this.$toast('请先登录')
          return false
        }

      },
      setCommentPraise (index) {
        if(this.source == 3||this.source == 7) {
          this.$appService.getToken(v => {
            if(v.token) {
              this.$store.dispatch('param/setToken', v.token)
            } else {
             var params={
              url:'',
              pagetype:0
            }
            this.$appService.needLogin(params)
          }
        })
        }else if(this.source == 1){
          if(localStorage.getItem('token')){
            this.token=true
          }else{
            this.getAuthorization.getAuthorization();
          }
        }

        if(this.user) {
          let type = this.comments[index].is_praise ? 2 : 1;
          ask.setCommentPraise({id: this.comments[index].id, type: type}).then(res => {
            if(res.data.state == 1) {
              if(type == 1) {
                this.comments[index].is_praise = 1
                this.comments[index].praise_num += 1
                // this.$toast.success('点赞成功')
              } else {
                this.comments[index].is_praise = 0
                this.comments[index].praise_num -= 1
                // this.$toast.success('取消成功')
              }
            }
          })
        } else {
          this.$toast('请先登录')
          return false
        }

      },
      toTip() {
        this.$toast.success('举报成功')
      },
      getInfo () {
        let user_id = this.user ? this.user.id : 0
        ask.getAnswerShow(this.answer_id, {user_id: user_id}).then(res => {
          if(res.data.state == 1) {
            this.info = res.data.data
            if(res.data.data.question){
              document.title = res.data.data.question;
              document.querySelector('meta[name="keywords"]').setAttribute('content', res.data.data.question)
              document.querySelector('meta[name="description"]').setAttribute('content', res.data.data.question)
            }
          }
        })
      },
      onClickLeft(){
        if(this.pageLength==1){
          this.$router.push({name:'Home'});
        }else{
          this.$router.go(-1)
        }
      },
  inputFocus(){//点击输入框聚焦
    if(this.source == 3||this.source == 7) {
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
         var params={
          url:'',
          pagetype:0
        }
        this.$appService.needLogin(params)
      }
    })
    }else if(this.source == 1){
      if(localStorage.getItem('token')){
        this.token=true
      }else{
        this.getAuthorization.getAuthorization();
      }
    }
    this.inputshow=false;
    this.overlay=true;
    this.inputnum=19;
    setTimeout(() => {
      var cc=document.getElementById('inputid');
      cc.scrollIntoViewIfNeeded(true);
    },500);
  },
      replys(rid){//点击回复聚焦
        if(this.source == 3||this.source == 7) {
          this.$appService.getToken(v => {
            if(v.token) {
              this.$store.dispatch('param/setToken', v.token)
            } else {
             var params={
              url:'',
              pagetype:0
            }
            this.$appService.needLogin(params)
          }
        })
        }else if(this.source == 1){
          if(localStorage.getItem('token')){
            this.token=true
          }else{
            this.getAuthorization.getAuthorization();
          }
        }
        this.inputshow=false;
        this.overlay=true;
        this.inputnum=19;
        this.inputfocus=true
        this.$refs.inputTag.focus()
        this.rid=rid
        setTimeout(() => {
          var cc=document.getElementById('inputid');
          cc.scrollIntoViewIfNeeded(true);
        },500);
      },
      touchstart(){//检测触发遮罩层，失去焦点
        this.inputshow=true;
        this.overlay=false;
        this.$refs.inputTag.blur()
        this.inputnum=14;
        this.inputfocus=false
      },
      inputBlur(){//点击失去焦点
        setTimeout(() => {
          this.inputshow=true;
          this.inputnum=14;
        }, 1000);
        this.overlay=false;
        this.inputfocus=false
        this.$refs.inputTag.blur()
      },
      post(){
        let params={
          rid:this.rid,
          answer_id:this.answer_id,
          content:this.value
        }
        ask.Comment(params).then(res => {
         if(res.data.state == 1) {
          this.inputshow=true;
          this.inputnum=14;
          this.overlay=false;
          this.inputfocus=false
          this.$refs.inputTag.blur()
          this.$toast.success('发表成功')
          this.value=''
          this.finished = false
          this.comments=[]
          this.params.page = 1
        }
      })
      },
      Collect(type){
        if(this.source == 3||this.source == 7) {
          this.$appService.getToken(v => {
            if(v.token) {
              this.$store.dispatch('param/setToken', v.token)
            } else {
             var params={
              url:'',
              pagetype:0
            }
            this.$appService.needLogin(params)
          }
        })
        }else if(this.source == 1){
          if(localStorage.getItem('token')){
            this.token=true
          }else{
            this.getAuthorization.getAuthorization();
          }
        }
        var param={
          id:this.info.answer.id,
          type: type==1?2:1
        }
        ask.Collect(param).then(res => {
          if(res.data.state == 1) {
            if(param.type == 1) {
              this.info.is_collect = 1
              this.info.collect += 1
            } else {
              this.info.is_collect = 0
              this.info.collect -= 1
            }
          }
        })
      },
      delComment(id,index){
        if(this.source == 3||this.source == 7) {
          this.$appService.getToken(v => {
            if(v.token) {
              this.$store.dispatch('param/setToken', v.token)
            } else {
             var params={
              url:'',
              pagetype:0
            }
            this.$appService.needLogin(params)
          }
        })
        }else if(this.source == 1){
          if(localStorage.getItem('token')){
            this.token=true
          }else{
            this.getAuthorization.getAuthorization();
          }
        }
        this.$dialog.confirm({
          message: '确定要删除吗？'
        }).then(() => {
         ask.delComment(id).then(res => {
          if(res.data.state == 1) {
            this.$toast.success('已删除')
            this.comments.splice(index,1);
          }
        })
       }).catch(() => {});
      },
      onCancel(){
        this.actionshow=false
      },
      outrelay(title,content,url,imageUrl){
        this.shareshow=true
        this.sharetitle=title
        this.sharecontent=content
        this.shareurl=this.weburl+url
        if(imageUrl){
          this.shareimageUrl=imageUrl
        }else{
          this.shareimageUrl='https://pic.motortime.com/logo/motortime_logo.png'
        }
        
      },
      toShare(type){
        var params={
          type:type,
          title:this.sharetitle,
          content:this.sharecontent,
          url:this.shareurl,
          imageUrl:this.shareimageUrl
        }
        this.shareshow=false
        this.$appService.shareContent(params)
      },
      onLoad() {
        this.params.user_id = this.user ? this.user.id : 0
      // 异步更新数据
      setTimeout(() => {
        ask.getCommentList(this.answer_id, this.params).then(res => {
          this.comments.push.apply(this.comments, res.data.data.data)
          this.params.page += 1
          this.loading = false

          if(res.data.data.data.length == 0) {
            this.finished = true
          }
        })
      }, 500);
    }
  },
  components: {
   [Row.name]: Row,
   [Col.name]: Col,
   [Tag.name]: Tag,
   [NavBar.name]:NavBar,
   [Grid.name]: Grid,
   [GridItem.name]: GridItem,
   [List.name]:List,
   [Field.name]:Field,
   [Button.name]:Button,
   [Overlay.name]:Overlay,
   [ActionSheet.name]:ActionSheet,
   [Divider.name]:Divider,
    [Icon.name]:Icon,
 }
};
</script>

<style lang="scss">
.ask-show-answer {
  background-color: #F0F0F0;
  // .van-nav-bar__left {
  //  left: 10px;
  // }
  .img {
    width: 100%;
    margin-top: 10px;
    border-radius: 5px;
    display: block;
  }
  .quespic {
    width: 22px;
    height: 22px;
    vertical-align: middle;
  }
  .q-show {
    padding: 10px;
    overflow: hidden;
    background-color: #FFF;

    h1 {
      font-size: 16px;
    }
    p {
      margin: 0;
      font-size: 14px;
    }
    .van-tag {
      color: #3A3A3A;
      padding: 0 5px;
      margin-right: 5px;
    }
    .tip {
      text-align: right;

      .c-blue {
        font-size: 12px;
        color: #FFF;
        background: #33A1FF url(../../../assets/img/answer-button.png) no-repeat 8px center;
        background-size: 13px auto;
        width: 80px;
        height: 25px;
        line-height: 25px;
        display: inline-block;
        text-align: left;
        padding-left: 25px;
        border-radius: 12px;
        box-sizing: border-box;
      }
    }
    
  }
  .a-show {
    padding: 10px;
    margin-top: 10px;
    background-color: #FFF;

    .listhand{
      width:45px;
      height:45px;
      border-radius:30px;
    }
    .membername{
      font-size: 15px;
      font-weight: bold;
    }
    .sourtime{
      font-size: 12px;
      color: #9A9A9A;
    }
    .bintright {
      text-align:right;

      .van-button--default {
        color: #F6AB00;
        border: 1px solid #F6AB00;
        width: 60px;
        height: 25px;
        line-height: 25px;
        font-size: 12px;
        padding: 0;
      }
    }
    .parise {
      text-align: center;
      margin-top: 10px;

      a {
        color: #3A3A3A;
        font-size: 11px;
        display: inline-block;
        width: 110px;
        height: 35px;
        border: 1px solid #9A9A9A;
        line-height: 35px;
        border-radius: 17px;
        box-sizing: border-box;
        margin: 0 6px;

        img {
          width: 15px;
          height: 14px;
          vertical-align: middle;
          margin: 0;
          margin-right: 7px;
        }
        &:first-child {
          margin-left: 0;
        }
        &:last-child {
          margin-right: 0;

          img {
            width: 13px;
          }
        }
      }
    }
  }
  .comments {
    background-color: #FFF;
    margin-top: 10px;

    h2 {
      font-size: 13px;
      font-weight: normal;
      padding: 15px 10px;
      border-bottom: 1px solid #EAEAEA;
      margin: 0;
    }
    .comment {
      margin: 0 10px;
      overflow: hidden;

      .van-row {
        border-bottom: 1px solid #EAEAEA;
        padding: 10px 0;
      }
      .avatar {
        width: 30px;
        height: 30px;
        object-fit: cover;
        border-radius: 15px;
      }
      h3 {
        font-size: 15px;
        margin: 0;

        .binbox {
          color: #9A9A9A;
          font-size: 12px;
          float: right;
          font-weight: normal;

          img {
            width: 15px;
            height: 14px;
            margin-right: 11px;
            vertical-align: middle;
          }
        }
      }
      p {
        font-size: 15px;
        margin: 5px 0;

        .c-blue {
          font-style: normal;
        }
        &.time {
          font-size: 12px;
          color: #9A9A9A;

          span {
            color: #3A3A3A;
            margin-left: 5px;
          }
        }
      }
      img {
        width: 280px;
        border-radius: 5px;
      }
      .replys {
        padding: 10px;
        background-color: #F7F7F7;

        p {
          font-size: 13px;
        }
      }
    }
    
  }
}
</style>
